import React, {useState} from 'react';
import {Badge, Spinner} from 'reactstrap';
import {ChevronDown, ChevronRight, Wrench, Server} from 'lucide-react';
import {ToolCallItem} from '../../api/types';

const formatArguments = (argumentsJson: string) => {
    try {
        return JSON.stringify(JSON.parse(argumentsJson), null, 2);
    } catch {
        return argumentsJson;
    }
};

const ToolCallItemView: React.FC<{item: ToolCallItem}> = ({item}) => {
    const [expanded, setExpanded] = useState(false);
    const isRunning = item.status === 'in_progress';
    const isFailed = item.status === 'failed' || !!item.error;

    return (
        <div className="mb-2 border rounded p-2 bg-light small">
            <div className="d-flex align-items-center gap-2">
                {item.source === 'mcp' ? (
                    <Server size={14} />
                ) : (
                    <Wrench size={14} />
                )}
                <button
                    type="button"
                    className="btn btn-link btn-sm p-0 text-decoration-none d-flex align-items-center gap-1"
                    onClick={() => setExpanded(value => !value)}
                >
                    {expanded ? (
                        <ChevronDown size={14} />
                    ) : (
                        <ChevronRight size={14} />
                    )}
                    <code>
                        {item.serverLabel
                            ? `${item.serverLabel} / ${item.toolName}`
                            : item.toolName}
                    </code>
                </button>
                {isRunning && <Spinner size="sm" />}
                {!isRunning && (
                    <Badge color={isFailed ? 'danger' : 'success'} pill>
                        {isFailed ? 'failed' : 'done'}
                    </Badge>
                )}
            </div>

            {(item.progressMessages?.length ?? 0) > 0 && (
                <div className="text-muted mt-1">
                    {item.progressMessages!.map((message, index) => (
                        <div key={index}>{message}</div>
                    ))}
                </div>
            )}

            {expanded && (
                <div className="mt-2">
                    <div className="fw-bold">Arguments</div>
                    <pre className="mb-2 bg-white border rounded p-2">
                        {formatArguments(item.argumentsJson)}
                    </pre>
                    {item.output && (
                        <>
                            <div className="fw-bold">Result</div>
                            <pre
                                className="mb-0 bg-white border rounded p-2"
                                style={{maxHeight: 240, overflow: 'auto'}}
                            >
                                {item.output}
                            </pre>
                        </>
                    )}
                    {item.error && (
                        <div className="text-danger">{item.error}</div>
                    )}
                </div>
            )}

            {!expanded && item.error && (
                <div className="text-danger mt-1">{item.error}</div>
            )}
        </div>
    );
};

export default ToolCallItemView;
